import React from 'react'
import classes from './CourseDetails.module.css'
import shieldIcon from '../../../assets/icons/shield.svg'
import { Button } from '../../../components/Button/Button'
import classNames from 'classnames'
import { convertToFormatted } from '../../../util/functions'

export const EarnPoints = ({ courseDetails, mobile = false }) => {
    return (
        <p
            className={classNames(
                classes.courseCardBottomLoyaltyPoints,
                classes.courseCardBottomMobileLoyaltyPoints
            )}
        >
            <img src={shieldIcon} alt="Shield" />
            <span>
                Earn{' '}
                <span className={classes.courseCardBottomLoyaltyPointsBold}>
                    {courseDetails.loyaltypoint}
                </span>{' '}
                Loyalty points for purchasing course
            </span>
        </p>
    )
}

export const BuyNowSnippet = ({ addToCart, buyNow, hasEnrolled }) => (
    <div className={classes.courseCardBottomLinks}>
        {!hasEnrolled && (
            <button
                className={classes.courseCardBottomLink}
                onClick={addToCart}
            >
                Add to cart
            </button>
        )}
        <Button
            bold={false}
            style={{ cursor: hasEnrolled ? 'not-allowed' : 'pointer' }}
            onClick={!hasEnrolled && buyNow}
        >
            {hasEnrolled ? 'Enrolled' : 'Buy Now'}
        </Button>
    </div>
)

export const UserChoices = ({ userChoice, setUserChoice, mobile = false }) => (
    <div
        className={classNames(
            classes.courseCardBottomChoices,
            mobile && classes.courseCardBottomMobileChoices
        )}
    >
        <button
            className={classNames(
                classes.courseCardBottomChoice,
                mobile && classes.courseCardBottomMobileChoice
            )}
            onClick={() => setUserChoice('purchase')}
        >
            <span
                className={classNames(
                    userChoice === 'purchase' &&
                        classes.courseCardBottomChoiceCheckboxActive,
                    classes.courseCardBottomChoiceCheckbox
                )}
            />
            Purchase this course only
        </button>
        <button
            className={classNames(
                classes.courseCardBottomChoice,
                mobile && classes.courseCardBottomMobileChoice
            )}
            onClick={() => setUserChoice('upgrade')}
        >
            <span
                className={classNames(
                    userChoice === 'upgrade' &&
                        classes.courseCardBottomChoiceCheckboxActive,
                    classes.courseCardBottomChoiceCheckbox
                )}
            />
            Upgrade plan and access free courses
        </button>
    </div>
)

export const FreePrice = ({ courseDetails }) => (
    <>
        <p className={classes.courseCardBottomFreePrice}>
            <span className={classes.courseCardBottomFreeLabel}>Free</span>
            <span className={classes.courseCardBottomFreeLabelOldPrice}>
                <s>{convertToFormatted(courseDetails.price, false, true)}</s>
            </span>
        </p>
    </>
)
